import { ThemeIcon, useMantineTheme } from '@mantine/core';
import { FC, ReactNode } from 'react';

interface GradientIconProps {
  color: string;
  children: ReactNode;
}

export const GradientIcon: FC<GradientIconProps> = ({ color, children }) => {
  if (color === 'green') {
    return <GreenGradientIcon>{children} </GreenGradientIcon>;
  }
  if (color === 'red') {
    return <RedGradientIcon>{children} </RedGradientIcon>;
  }
  if (color === 'orange') {
    return <OrangeGradientIcon>{children} </OrangeGradientIcon>;
  }
  if (color === 'gray') {
    return <GrayGradientIcon>{children} </GrayGradientIcon>;
  }
  return <BlueGradientIcon>{children} </BlueGradientIcon>;
};

export const GrayGradientIcon: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.gray[5], to: colors.gray[9], deg: 135 }
          : { from: colors.gray[4], to: colors.gray[0], deg: 135 }
      }
    >
      {children}
    </ThemeIcon>
  );
};

export const OrangeGradientIcon: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.orange[1], to: colors.orange[5], deg: 135 }
          : { from: colors.orange[4], to: colors.orange[0], deg: 135 }
      }
    >
      {children}
    </ThemeIcon>
  );
};

export const BlueGradientIcon: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.blue[1], to: colors.blue[5], deg: 135 }
          : { from: colors.blue[4], to: colors.blue[0], deg: 135 }
      }
    >
      {children}
    </ThemeIcon>
  );
};

export const RedGradientIcon: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.red[2], to: colors.red[6], deg: 135 }
          : { from: colors.red[4], to: colors.red[0], deg: 135 }
      }
    >
      {children}
    </ThemeIcon>
  );
};

export const GreenGradientIcon: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      size="xl"
      radius="xl"
      variant="gradient"
      gradient={
        darkMode
          ? { from: colors.green[4], to: colors.green[8], deg: 135 }
          : { from: colors.green[0], to: colors.green[4], deg: 135 }
      }
    >
      {children}
    </ThemeIcon>
  );
};
